var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.setup && _vm.loaded)?[_c('router-view')]:[_c('pulse-loader'),_c('v-app',[_c('primeit-validate-current-time')],1)],_c('dav-timezone')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }